export interface LoyaltyCreditCardFeatureFlag {
  hasResolvedFlag: boolean
  isEnabled: boolean
}

// Credit card availability requires both the AU region and an enabled LE Lab
// decision. Non-AU regions resolve as disabled immediately; AU remains
// unresolved until LE Lab returns a decision. Bots may remain unresolved
// because they skip the LE Lab request.
export function resolveLoyaltyCreditCardFeatureFlag(
  flag: App.LabFeatureFlagResult | undefined,
  currentRegionCode: string,
): LoyaltyCreditCardFeatureFlag {
  // An empty region means geo state has not resolved (or failed), not that
  // the visitor is outside AU — fall through so the page keeps loading rather
  // than bouncing a possibly-AU visitor.
  if (currentRegionCode && currentRegionCode !== 'AU') {
    return {
      hasResolvedFlag: true,
      isEnabled: false,
    }
  }

  return {
    hasResolvedFlag: flag !== undefined,
    isEnabled: !!flag?.enabled,
  }
}
